import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const MicrosurveyBase = (
  <path
    fill='currentColor'
    fillRule='evenodd'
    d='M4 3c-.552 0-1 .448-1 1v8c0 .552.448 1 1 1h8c.552 0 1-.448 1-1V4c0-.552-.448-1-1-1H4zm2.628 7.73c.175.174.42.234.644.18.15-.023.293-.096.403-.218l3.65-4.054c.252-.28.23-.71-.05-.963-.28-.252-.712-.23-.964.05L7.11 9.283 5.664 7.836c-.266-.266-.698-.266-.964 0-.267.267-.267.698 0 .965l1.928 1.929zM1.5 12c.276 0 .5-.224.5-.5v-7c0-.276-.224-.5-.5-.5s-.5.224-.5.5v7c0 .276.224.5.5.5zm13.5-.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-7c0-.276.224-.5.5-.5s.5.224.5.5v7z'
  />
)

export const Microsurvey = createIcon({
  displayName: 'Microsurvey',
  viewBox: '0 0 16 16',
  path: MicrosurveyBase,
})
